import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import "./ViewCart.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaTrashAlt } from "react-icons/fa";
import { IoMdArrowDropright, IoMdArrowDropleft } from "react-icons/io";
import { Scrollbars } from "react-custom-scrollbars-2";
import { SetQty, RemoveItem, ClearCart } from "../components/Redux/Action";
import { HiMinusSm, HiPlusSm } from "react-icons/hi";

const ViewCart = () => {
  const cartItems = useSelector((state) => state.Reducer);
  const dispatch = useDispatch();

  let total = 0;
  cartItems.map((item) => {
    let d = item.promoPercentage
      ? item.unitRetail - (item.unitRetail * item.promoPercentage) / 100
      : item.unitRetail;
    let x_total = total + d * item.qty;
    total = Number(x_total.toFixed(0));
  });

  const increment = (item) => {
    if (item.qty < 10) {
      item.qty += 1;
      dispatch(SetQty({ ...item }));
    }
  };

  const decrement = (item) => {
    if (item.qty > 1) {
      item.qty -= 1;
      dispatch(SetQty({ ...item }));
    }
  };

  return (
    <>
      <Header />
      <center>
        <h3 className="top-hadding">Your Cart</h3>
      </center>
      {cartItems.length > 0 ? (
        <div className="main">
          <div className="second-main">
            {/* Table View for Large Screens */}
            <div className="container large-screen">
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Subtotal</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems?.map((item) => (
                    <tr key={item.barcode}>
                      <td>
                        <div className="product-info-table">
                          <img
                            className="cart-image"
                            src={`${window.imagesapi}/images/ProductImages/${item?.barcode}.webp?v=${item?.updateTicks}`}
                            alt={item.description}
                          />
                          <span>{item.description}</span>
                        </div>
                      </td>
                      <td>
                        Rs.{" "}
                        {item.promoPercentage
                          ? Math.round(
                              item.unitRetail -
                                (item.unitRetail * item.promoPercentage) / 100
                            )
                          : item.unitRetail}
                      </td>
                      <td>
                        <div className="qty-controls">
                          <a className="plus-a" onClick={() => increment(item)}>
                            <HiPlusSm />
                          </a>
                          <span>{item.qty}</span>
                          <a
                            className="minus-a"
                            onClick={() => decrement(item)}
                          >
                            <HiMinusSm />
                          </a>
                        </div>
                      </td>
                      <td>
                        Rs.{" "}
                        {item.promoPercentage
                          ? Math.round(
                              item.unitRetail -
                                (item.unitRetail * item.promoPercentage) / 100
                            ) * item.qty
                          : item.unitRetail * item.qty}
                      </td>
                      <td>
                        <a onClick={() => dispatch(RemoveItem(item))}>
                          <FaTrashAlt />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Card View for Small Screens */}
            <div className="container small-screen">
              {cartItems?.map((item) => (
                <div className="viewcart-product card" key={item.barcode}>
                  <div className="product-info">
                    <img
                      className="cart-image"
                      src={`${window.imagesapi}/images/ProductImages/${item?.barcode}.webp?v=${item?.updateTicks}`}
                      alt={item.description}
                    />
                    <p>{item.description}</p>
                  </div>
                  <p className="price">
                    Price: Rs.{" "}
                    {item.promoPercentage
                      ? Math.round(
                          item.unitRetail -
                            (item.unitRetail * item.promoPercentage) / 100
                        )
                      : item.unitRetail}
                  </p>
                  <div className="qty-controls">
                    <button className="plus-a" onClick={() => increment(item)}>
                      <HiPlusSm />
                    </button>
                    <span>{item.qty}</span>
                    <button className="minus-a" onClick={() => decrement(item)}>
                      <HiMinusSm />
                    </button>
                  </div>
                  <p className="subtotal">
                    Subtotal: Rs.{" "}
                    {item.promoPercentage
                      ? Math.round(
                          item.unitRetail -
                            (item.unitRetail * item.promoPercentage) / 100
                        ) * item.qty
                      : item.unitRetail * item.qty}
                  </p>
                  <a
                    className="remove-item"
                    onClick={() => dispatch(RemoveItem(item))}
                  >
                    <FaTrashAlt />
                  </a>
                </div>
              ))}
            </div>

            {/* Cart Footer */}
            <div className="cart-footer">
              <div>
                <button
                  onClick={() => dispatch(ClearCart())}
                  className="clear-cart"
                >
                  Clear Cart
                </button>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <span className="card-total">Total: Rs. {total}</span>
                <Link to="/checkout">
                  <button className="checkout-button">Checkout</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="no-items">No Items Added to Cart!</div>
      )}

      <Footer />
    </>
  );
};

export default ViewCart;
